import React, { useState } from "react";
import "./loginpage.css";
import useLogin from "../../hooks/useLogin";

function LoginPage() {
    const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { login } = useLogin();

  const handleSubmit = (e) => {
    e.preventDefault();
     login(username, password, setErrorMessage);
  };

  return (
    <div className="login-page">
      <div className="login-overlay">
        <div className="login-info">
          <h2>APPLICATION DE FACTURATION</h2>
          <p>
            Avec <strong>Mon Compte</strong>,<br />
            La Facturation me simplifie le travail au quotidien.
          </p>
        </div>

        <div className="login-card">
          <h3>Connectez-vous</h3>
          <form onSubmit={handleSubmit} className="form_login">
            <label>
              Renseignez votre identifiant
          
            </label>   
             <input
              id="username"
              type="text"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Identifiant"
              required
            />            <label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mot de passe"
                required
              />
            </label>

            <div className="login-options">
              <label>
                <input type="checkbox" />
                Rester connecté
              </label>
              {/* <a href="/forgot-password" className="forgot-password">
                j’ai oublié mon mot de passe
              </a> */}
            </div>

            {errorMessage && <div className="error-message">{errorMessage}</div>}

            <button type="submit" className="login-button">
              Se connecter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
